import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import DatePickerField from 'next/javascripts/components/form-fields/date-picker-field/index.js';
import './todo-date-field/result';

export default Component('tr-todo-date-field', {
  extends: [DatePickerField],

  mixins: [eventListenerMixin],

  properties: {
    pill: {
      type: Boolean,
      default: true,
    },

    openOnReady: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    if (this.openOnReady) {
      this.list.open();
      this.openOnReady = false;
    }
  },

  beforeCache() {
    this.list.close();
    this.openOnReady = false;
  },
});
